import { render, staticRenderFns } from "./barItem.vue?vue&type=template&id=f67ecd52&"
import script from "./barItem.vue?vue&type=script&lang=js&"
export * from "./barItem.vue?vue&type=script&lang=js&"
import style0 from "./barItem.vue?vue&type=style&index=0&id=f67ecd52&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports